import React, { lazy } from 'react';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const cleanFilters = (filters) => {
  const cleanedFilters = { ...filters };
  Object.keys(cleanedFilters).forEach((key) => {
    if (cleanedFilters[key] === null || cleanedFilters[key] === '') {
      delete cleanedFilters[key];
    }
  });
  return cleanedFilters;
};

const filterResults = (list, companyName) => {
  return list?.list.filter((item) =>
    item?.companyName ? item.companyName === companyName : ''
  );
};

const handleFormSubmit = ({
  values,
  list,
  filterSuccess,
  setPagination,
  setErrorMessage,
}) => {
  if (values.companyId?.value) {
    setErrorMessage('');
    setPagination(true);

    const cleanedFilters = cleanFilters(values);
    const result = filterResults(list, values.companyId?.label);
    filterSuccess(result);
  } else {
    setErrorMessage('Please select a company');
  }
};

const handleFormCancel = ({ setPagination, setErrorMessage, setValues, list, filterSuccess }) => {
  setPagination(true);
  setErrorMessage('');
  setValues({ companyId: null });
  filterSuccess(list.list);
};

const filterAlertListForm = (
  values,
  list,
  filterSuccess,
  setValues,
  i18n,
  setPagination,
  fleetCompanyList,
  setErrorMessage
) => {
  return (
    <Form
      type="client"
      direction="row"
      values={{ ...values }}
      className="filterForm"
      handleOnSubmit={() =>
        handleFormSubmit({
          values,
          list,
          filterSuccess,
          setPagination,
          setErrorMessage,
        })
      }
      handleOnCancel={() =>
        handleFormCancel({
          setPagination,
          setErrorMessage,
          setValues,
          list,
          filterSuccess,
        })
      }
      setValues={setValues}
      fields={[
        {
          type: 'select',
          value: '',
          field: 'companyId',
          placeholder: i18n.t('dashboard.tabs.radiusComplianceAlerts.company'),
          label: i18n.t('dashboard.tabs.radiusComplianceAlerts.company'),
          suggestions: fleetCompanyList,
        },
        { type: 'submit', value: i18n.t('common.view') },
        { type: 'reset', value: i18n.t('common.clear') },
      ]}
    />
  );
};

export default filterAlertListForm;
